﻿import Nav from './nav';
import SvgManager from '../../core/SvgManager';

const icons = {
	open: '../images/OpenInTab.svg',
	add: '../images/New.svg',
	edit: '../images/Edit.svg',
	delete: '../images/Delete.svg'
};
SvgManager.enqueue(Object.values(icons));

const dashboardProperties = ['startPage', 'formId'];
const isDashboard = (item) => {
	const { additional_data: additionalData, on_click_handler: handler } = item;
	if (handler) {
		return true;
	}

	if (!additionalData) {
		return false;
	}

	return (
		dashboardProperties.some((property) => additionalData[property]) ||
		!additionalData.itemTypeId
	);
};

class NavEditor extends Nav {
	constructor() {
		super();

		this.modifier = 'editor';
	}

	formatter(item) {
		const result = [];
		const {
			children,
			'@aras.action': action,
			related_id: relatedId
		} = item.value;
		const relatedItem = this.data.get(relatedId);
		const { image, name, label, '@aras.action': relatedAction } = relatedItem;
		const status = action || relatedAction;

		if (status) {
			if (status === 'delete') {
				result.push(<div className="aras-nav__deleted-row-mask"></div>);
			}

			const statusIndicatorClass = 'aras-nav__status-indicator';
			const icon = SvgManager.createInfernoVNode(icons[status], {
				class: `${statusIndicatorClass}-icon`
			});
			const statusClass = `${statusIndicatorClass} ${statusIndicatorClass}_${status}`;
			result.push(<div className={statusClass}>{icon}</div>);
		}

		if (!children) {
			result.push(<span className="aras-nav__tree-levelpad" />);
		}

		if (image) {
			const iconNode = SvgManager.createInfernoVNode(image, {
				class: `aras-nav__row__icon`
			});
			result.push(iconNode);
		}

		const labelNode = <span className="aras-nav__label">{label || name}</span>;
		result.push(labelNode);

		const isDashboardItem = isDashboard(relatedItem);
		if (!children && isDashboardItem) {
			result.push(
				<span className="aras-nav-leaf-ico">
					{SvgManager.createInfernoVNode(icons.open)}
				</span>
			);
		}

		return result;
	}
}

const name = 'aras-nav-editor';
if (!customElements.get(name)) {
	customElements.define(name, NavEditor);
}

export default NavEditor;
